<glxy-form-field [bottomSpacing]="bottomSpacing">
  <glxy-label *ngIf="placeholder">{{ placeholder }}</glxy-label>
  <textarea matInput [placeholder]="placeholder" [formControl]="control" [required]="required"></textarea>
  <glxy-hint *ngIf="tooltip" align="start" [matTooltip]="tooltip">
    <a (click)="(null)" class="link">
      {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
    </a>
  </glxy-hint>
  <glxy-hint
    align="end"
    *ngIf="maxLength"
    [ngStyle]="{
      color: (control.value || '').length > maxLength ? 'red' : null
    }"
  >
    {{ (control.value || '').length }}/{{ maxLength }}
  </glxy-hint>
  <glxy-error *ngIf="errorOutput(control)">{{ errorOutput(control) }}</glxy-error>
</glxy-form-field>
